/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-03-22 09:51:20
 * @FilePath: \community-backendf:\community-frontend\src\service\user.js
 * @Description: 
 */
import { get, post } from './http'

const userPath = '/user/frontend/'

const USER = {
  // 获取举报列表
  getReportReason: () => {
    return get(`${userPath}contentreport/getReasons`)
  },
  // 获取用户信息
  getUserInfo: (params) => {
    return get(`${userPath}user/info`, params)
  },
  // 关注
  follow: (params) => {
    params.needAuth = true
    params.needToastErr = true
    return post(`${userPath}follow/create`, params)
  },
  // 取消关注
  unFollow: (params) => {
    params.needAuth = true
    params.needToastErr = true
    return post(`${userPath}follow/cancel`, params)
  },
  // 获取关注列表
  getFollowingList: (params) => {
    return get(`${userPath}following/list`, params)
  },
  // 收藏
  mark: (params) => {
    params.needAuth = true
    return post(`${userPath}thread/collection/add`, params)
  },
  // 取消收藏
  unmark: (params) => {
    params.needAuth = true
    return post(`${userPath}thread/collection/remove`, params)
  },
  // 粉丝列表
  getFollowerList: (params) => {
    return get(`${userPath}follower/list`, params)
  },
  // 关注列表
  getFollowingList: (params) => {
    return get(`${userPath}following/list`, params)
  },
  // 举报
  report: (params) => {
    params.needAuth = true
    return post(`${userPath}contentreport/add`, params)
  },
  // 获取用户帖子列表
  getUserThreadList: (params) => {
    return get(`${userPath}thread/page`, params)
  },
  // 获取用户评论列表
  getUserCommentList: (params) => {
    return get(`${userPath}comment/page`, params)
  },
  // 获取用户收藏列表
  getUserMarkList: (params) => {
    return get(`${userPath}thread/collection/page`, params)
  },
  // 获取用户点赞列表
  getUserLikeList: (params) => {
    return get(`${userPath}thread/likes`, params)
  },
  // 检查姓名
  checkUserName: (params) => {
    return post(`${userPath}user/check-name`, params)
  },
  // 用户信息修改
  updateUserInfo: (params) => {
    params.needAuth = true
    return post(`${userPath}user/update`, params)
  },
  // 搜索用户
  getUserList: (params) => {
    return get(`${userPath}user/page`, params)
  },
  // 发起积分国家查询
  openPointsSearch: (params) => {
    return post(`${userPath}credit/userCountryCode`, params)
  },
  // 获取积分国家配置
  getUserCountry: (params) => {
    return get(`${userPath}credit/userCredit`, params)
  },
  // 获取用户当前积分
  getUserPoints: (params) => {
    return get(`${userPath}credit/info`, params)
  },
  // 获取用户积分历史
  getPointsRecord: (params) => {
    return get(`${userPath}credit/record`, params)
  },
  block: (params) => {
    return post(`${userPath}blacklist/add`, params)
  },
  unblock: (params) => {
    return post(`${userPath}blacklist/remove`, params)
  },
  getBlockList: (params) => {
    return get(`${userPath}blacklist/page`, params)
  },
  // getTicket: (params) => {
  //   return get(`${userPath}login/getByTicket`, params)
  // },
  // clearTicket: () => {
  //   return get(`${userPath}login/kickOut`)
  // },
  getTicket: (params) => {
    return get(`/authorize/frontend/login`, params)
  },
  clearTicket: () => {
    return get(`/authorize/frontend/logout`)
  },
  // 查询用户隐私设置
  getPrivacySettings: () => {
    return get(`${userPath}user/settings/list`)
  },
  // 更新用户隐私设置
  updatePrivacySettings: (params) => {
    return post(`${userPath}user/settings/update`, params)
  },
  // 查询标记用户
  getMarkUser: (params) => {
    return get(`${userPath}user/mark`, params)
  },
  // 获取个人中心客服入口
  getCustomerService: (params) => {
    return get(`${userPath}credit/customerService`)
  },
  // 禁言
  muteUser: (params) => {
    return post(`${userPath}punish/add`, params)
  },
  // 取消禁言
  unMuteUser: (params) => {
    return post(`${userPath}punish/cancel`, params)
  },
  // 个人主页帖子置顶
  stickProfile: (params) => {
    return post(`${userPath}thread/top/add`, params)
  },
  // 个人主页帖子取消置顶
  unStickProfile: (params) => {
    return post(`${userPath}thread/top/cancel`, params)
  },
  // 广告位配置(积分和邀请制)
  getCenterBannerList: (params) => {
    return get(`operate/frontend/profile/banners`, params)
  },
  //保存push订阅
  saveTokenToServer: (params) => {
    return post(`${userPath}login/index`, params)
  },
  getReportRecordList: (params) => {
    return get(`${userPath}contentreport/list`, params)
  },
  getPersonalCollectInfo: (params) => {
    return get(`${userPath}privacy/list`, params)
  },
}


export default USER